import { Capacitor } from '@capacitor/core';
import { logEvent } from 'firebase/analytics';
import { firebaseAnalytics, isInIframe } from './firebase';
import { getStorageKey, setStorageKey } from './storage';
import SworkitMobile from './sworkit-mobile/sw-mobile';

export async function trackFunnelEventFa(
  faEventName: FirebaseEventName,
  faParamsObject?: object
) {
  const alreadyTracked = await getStorageKey(faEventName);
  if (!alreadyTracked) {
    const logged = logFirebaseAnalyticsEvent(faEventName, faParamsObject);
    if (logged) {
      setStorageKey(faEventName, 'true');
      console.debug('FA logged event once', faEventName, faParamsObject);
    }
  } else {
    console.debug('FA event already tracked', faEventName, faParamsObject);
  }
}

export function logFirebaseAnalyticsEvent(
  faEventName: FirebaseEventName,
  parameters: object = {}
) {
  if(isInIframe()) return false;
  if (Capacitor.isNativePlatform() && SworkitMobile && SworkitMobile.logEvent) {
    SworkitMobile.logEvent({ name: faEventName, parameters });
    console.debug('Track event FA only', faEventName, parameters);
    return true;
  } else if (Capacitor.isNativePlatform()) {
    console.debug('SworkitMobile.logEvent not found');
    return false;
  } else {
    logEvent(firebaseAnalytics, faEventName, parameters);
    return true;
  }
}

export type FirebaseEventName =
  // must be under 36 characters long
  | 'sw_fa_welcome_play_syi_video'
  | 'sw_fa_welcome_play_sworkit_video'
  | 'sw_fa_create_account'
  | 'sw_fa_subscribe'
  | 'sw_fa_welcome_experiment'
  | 'sw_fa_rec_first_experiment'
  | 'sw_fa_welcome_gender'
  | 'sw_fa_welcome_birth_year'
  | 'sw_fa_welcome_weight'
  | 'sw_fa_welcome_activity_level'
  | 'sw_fa_welcome_connect_devices'
  | 'sw_fa_welcome_help'
  | 'sw_fa_welcome_interest'
  | 'sw_fa_welcome_injuries'
  | 'sw_fa_welcome_pain'
  | 'sw_fa_welcome_goal'
  | 'sw_fa_welcome_struggle'
  | 'sw_fa_welcome_recommendation'
  | 'sw_fa_first_workout_free_exp'
  | 'sw_fa_free_workout_button'
  | 'sw_fa_no_free_workout_button'
  | 'sw_fa_pricing_tier_experiment'
  | 'sw_fa_8999_pricing_tier'
  | 'sw_fa_5999_pricing_tier'
  | 'sw_fa_workout_end'
  | 'sw_fa_welcome_pt'
  | 'sw_fa_welcome_kids_intent'
  | 'sw_fa_view_purchase_screen'
  | 'sw_fa_search_no_workouts'
  | 'sw_fa_search_no_exercises';
